const setTitle = (title?: string) => {
  document.title = title ? `${title} - Portal de Negociação` : 'Portal de Negociação'
}

export default setTitle
